// extracted by mini-css-extract-plugin
module.exports = {"round":"_1sl1b"};